import { Component, Input } from '@angular/core';
import { ErrorService } from '@app/services';
import { EntityTableComponent } from '@app/abstracts';
import { ModuleQCMSearchParams } from '../module-qcm-search-params';
import { ModuleQCMService } from '../module-qcm.service';
import { ModuleQCM } from '../module-qcm';

@Component({
	selector: 'hpf-module-qcm-table',
	templateUrl: './module-qcm-table.component.html',
})
export class ModuleQCMTableComponent extends EntityTableComponent<
	ModuleQCM,
	ModuleQCMSearchParams
> {
	/** Columns to show */
	@Input() columns = ['created_at', 'title', 'question'];
	/** Constructor */
	constructor(
		private moduleQCMService: ModuleQCMService,
		private errorService: ErrorService
	) {
		super();
	}
	/** @inheritDoc */
	protected refresh(): void {
		const params = this.searchParams.toObject();
		params._populate = ['title.lang'];
		// Set refreshing flag
		this.refreshing = true;
		// Get list
		this.moduleQCMService
			.list(params)
			.then((results) => {
				// Link data
				this.items = results.items;
				this.total = results.total;
			})
			.catch((error) => this.errorService.handle(error))
			.then(() => {
				this.refreshing = false;
			});
	}

	/** Called when the user select multiple rows and delete them */
	async removeMany() {
		if (!this.selectedRows.length) {
			return;
		}

		this.deleting = true;
		for (const item of this.selectedRows) {
			await this.moduleQCMService
				.remove(item.getId())
				.catch((e) => this.errorService.handle(e));
		}

		this.deleteMany.next(this.selectedRows);
		this.resetSelectedRows();
		this.deleting = false;
		this.deleteManyModal = false;
		this.searchParams.next();
	}
	/** Called when the user delete a single row */
	async removeOne() {
		if (!this.rowToDelete) {
			return;
		}

		this.deleting = true;
		await this.moduleQCMService
			.remove(this.rowToDelete.getId())
			.catch((e) => this.errorService.handle(e));

		this.deleteOne.next(this.rowToDelete);
		delete this.rowToDelete;
		this.deleting = false;
		this.deleteOneModal = false;
		this.searchParams.next();
	}
}
